export default "/images/certificate1.png?634da5aa7a9fd57214b510422fbbff93";